import { FC } from "react";
import SWDCGlobalSimpleFooter, {
  LinkProps,
} from "@/components/SWDCGlobalSimpleFooter/SWDCGlobalSimpleFooter";
import { BuilderBlockProps, Theme } from "@/types";

type SWDCGlobalSimpleFooterBlockProps = {
  theme?: Theme;
  legal_links: Array<LinkProps>;
  copyright: string;
  animatedTopLine?: boolean;
} & BuilderBlockProps;

export const SWDCGlobalSimpleFooterBlock: FC<
  SWDCGlobalSimpleFooterBlockProps
> = ({ legal_links, copyright, theme, animatedTopLine }) => {
  return (
    <SWDCGlobalSimpleFooter
      legal_links={legal_links}
      copyright={copyright}
      theme={theme}
      animatedTopLine={animatedTopLine}
    />
  );
};
